import React from 'react'
import Styles from './styles'
import { useSearchParamsHandler } from '~/contexts/FilterContext'
import { FormattedMessage } from 'react-intl'

import { ReactComponent as SortIcon } from '../../../../../../assets/img/svg/sort.svg'
import { ReactComponent as SortUpIcon } from '../../../../../../assets/img/svg/sort-up.svg'
import { ReactComponent as SortDownIcon } from '../../../../../../assets/img/svg/sort-down.svg'
import useListViewColumn from './useListViewColumn'

export default function Table({ userIsClient, locations }) {
  const [extendedRow, setExtendedRow] = React.useState(null)
  const { query, setQueries } = useSearchParamsHandler()
  const { sort, sortBy } = query
  const { columns } = useListViewColumn(userIsClient)
  const [freeWidth, freeColumns] = React.useMemo(() => {
    let freeColumns = 0
    const usedWidth = (columns || []).reduce((acc, column) => {
      if (!column.width) freeColumns++
      return acc + (column.width ? parseInt(column.width) : 0)
    }, 0)
    return [100 - usedWidth, freeColumns]
  }, [columns])

  function handleSort(id) {
    const newSort = sortBy === id ? (sort === 'ASC' ? 'DESC' : 'ASC') : 'ASC'
    setQueries({
      sort: newSort,
      sortBy: id,
      page: 1,
    })
  }
  return (
    <Styles.CustomTable>
      <Styles.Thead>
        {(columns || []).map(column => {
          return (
            <>
              {column.sortable ? (
                <Styles.ThButton
                  key={`col-${column.id}`}
                  onClick={() => handleSort(column.id)}
                  data-centered={column.centered}
                  width={
                    column.width
                      ? column.width
                      : (freeWidth / freeColumns).toFixed(2) + '%'
                  }
                >
                  {column?.title && <FormattedMessage id={column.title} />}
                  {(!sort || sortBy !== column.id) && <SortIcon />}
                  {sort === 'ASC' && sortBy === column.id && <SortDownIcon />}
                  {sort === 'DESC' && sortBy === column.id && <SortUpIcon />}
                </Styles.ThButton>
              ) : (
                <Styles.ThDiv
                  key={`col-${column.id}`}
                  data-centered={column.centered}
                  width={
                    column.width
                      ? column.width
                      : (freeWidth / freeColumns).toFixed(2) + '%'
                  }
                >
                  {column?.title && <FormattedMessage id={column.title} />}
                </Styles.ThDiv>
              )}
            </>
          )
        })}
      </Styles.Thead>
      <Styles.Tbody>
        {(locations || []).map((item, index) => {
          const isExtended = extendedRow === `row-${index}`
          const extend = () =>
            setExtendedRow(isExtended ? null : `row-${index}`)

          return (
            <>
              <Styles.Tr key={`row-${index}`}>
                {(columns || []).map((column, i) => {
                  const cell = column.cell
                  const selector = column.selector || (item => item[column.id])
                  const value = cell
                    ? cell(item, isExtended, extend)
                    : selector(item)

                  return (
                    <Styles.Td
                      key={`cell-${i}-${index}`}
                      data-centered={column.centered}
                      width={
                        column.width
                          ? column.width
                          : (freeWidth / freeColumns).toFixed(2) + '%'
                      }
                    >
                      {value}
                    </Styles.Td>
                  )
                })}
              </Styles.Tr>
            </>
          )
        })}
      </Styles.Tbody>
    </Styles.CustomTable>
  )
}
